// src/entry/venue-main.jsx — Vite entry for venue.html.
// Extracted from venue.html inline <script type="text/babel"> on 2026-05-27.
// VenuePage is attached to window.VenuePage by components/VenuePage.jsx
// after Vite compiles it; this entry runs after all venue components have
// loaded (module scripts execute in DOM order).

/* eslint-disable no-unused-vars */
const VenuePage = window.VenuePage;
const Footer = window.Footer;
/* eslint-enable no-unused-vars */

const root = ReactDOM.createRoot(document.getElementById('venue-root'));
root.render(
  <React.Fragment>
    <VenuePage />
    {Footer ? <Footer /> : null}
  </React.Fragment>
);
